import {writable} from 'svelte/store';

import {NotificationTypes} from '../types/notifications';

// Whether to show the notification message or not
export const showNotification = writable<boolean>(false);

// The type of the notification message
export const notificationType = writable<NotificationTypes>(
  NotificationTypes.DEFAULT
);

// The texts for the notification message to show
export const notificationTitle = writable<string>('');
export const notificationDescription = writable<string>('');

function createNotification() {
  const {subscribe} = writable({
    show: showNotification,
    type: notificationType,
    title: notificationTitle,
    description: notificationDescription
  });

  const resetNotification = () => {
    showNotification.set(false);
    notificationType.set(NotificationTypes.DEFAULT);
    notificationTitle.set('');
    notificationDescription.set('');
  };

  return {
    subscribe,
    show: (type: NotificationTypes, title: string, description: string) => {
      showNotification.set(true);
      notificationType.set(type);
      notificationTitle.set(title);
      notificationDescription.set(description);

      // Reset notification after 5s
      setTimeout(resetNotification, 5000);
    },
    hide: resetNotification
  };
}

export const notification = createNotification();
